import _extends from "@babel/runtime/helpers/esm/extends";
import { Progress } from 'antd';
import React from 'react';
import { useStyles } from "./RotatableProgress.style";
export var RotatableProgress = function RotatableProgress(properties) {
  var _useStyles = useStyles(),
    styles = _useStyles.styles;
  return /*#__PURE__*/React.createElement(Progress, _extends({
    type: "circle",
    className: styles.indicator
  }, properties));
};